import castArray from "lodash/fp/castArray";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";
import has from "lodash/fp/has";
import some from "lodash/fp/some";
import isNil from "lodash/fp/isNil";

// custom conditions
export const conditions = {
  skateBootLengthCheck(userChoiceValues) {
    const sizeLeft = parseFloat(userChoiceValues?.size_left || "100");
    const sizeRight = parseFloat(
      userChoiceValues?.size_right || sizeLeft.toString()
    );
    if (
      sizeLeft < 4 ||
      sizeRight < 4 ||
      sizeLeft > 12.75 ||
      sizeRight > 12.75 ||
      Math.abs(sizeLeft - sizeRight) >= 0.75
    ) {
      return false;
    }
    return true;
  },

  skateCheckForCarbonLite(userChoiceValues) {
    const sizeLeft = parseFloat(userChoiceValues?.size_left || "100");
    const sizeRight = parseFloat(
      userChoiceValues?.size_right || sizeLeft.toString()
    );
    const holder = userChoiceValues?.Holder;
    if (
      sizeLeft < 4 ||
      sizeRight < 4 ||
      sizeLeft > 12.75 ||
      sizeRight > 12.75 ||
      holder === "Powerfly"
    ) {
      return false;
    }
    return true;
  },

  skateBootLengthCheckForHolder(userChoiceValues) {
    const sizeLeft = parseFloat(userChoiceValues?.size_left || "100");
    const sizeRight = parseFloat(
      userChoiceValues?.size_right || sizeLeft.toString()
    );
    const bladeType = userChoiceValues["Blade Type"];
    if (sizeLeft >= 13 || sizeRight >= 13 || bladeType === "LS CarbonLite") {
      return false;
    }
    return true;
  },
};

function testDisplayIfConditions(userChoiceValues) {
  return (obj) => {
    const { condition, ...displayIfFields } = obj;

    if (condition && conditions.hasOwnProperty(condition)) {
      return conditions[condition](userChoiceValues);
    }

    return Object.keys(displayIfFields).every((fieldName) => {
      const displayIf = displayIfFields[fieldName];
      const fieldValue = userChoiceValues[fieldName];

      return Object.keys(displayIf).every((key) => {
        if (key === "isNil") {
          return displayIf.isNil ? isNil(fieldValue) : !isNil(fieldValue);
        }

        if (!has(fieldName)(userChoiceValues)) {
          return true;
        }

        if (key === "notIncludes") {
          return !displayIf.notIncludes.includes(fieldValue);
        }

        if (key === "includes") {
          return displayIf.includes.includes(fieldValue);
        }

        return true;
      });
    });
  };
}

/*
===============================================================================
Will check for a `displayIf` value on Object
===============================================================================
`displayIf` can be an Object
all conditions of the object must be true, to return true (AND)
{
  displayIf: {
    // redux store user values key
    color: {
      // includes or notIncludes (not both)
      includes: [
        // array of values that user value can be
        "red",
        "black"
      ]
    }
  }
}

OR `displayIf` can be an array of above Objects
all conditions of the object must be true, to return true (AND)
and at least one of these in the array must return true, to return true (OR)
{
  displayIf: [
    {
      color: {
        includes: ["red"]
      }
    },
    {
      size: {
        includes: ["large"]
      }
    },
  ]
}

*/

export default function shouldBeDisplayed(userChoiceValues) {
  return (obj) => {
    if (obj?.displayIf) {
      return flow(
        getOr([], ["displayIf"]),
        castArray,
        some(testDisplayIfConditions(userChoiceValues))
      )(obj);
    }

    return true;
  };
}
